import { apiFetch } from "../utils/api";

export const getAllDevicesBasic = async () => {
  const res = await apiFetch("/api/devices");
  if (!res.ok) throw new Error("Failed to fetch basic device list");
  return res.json();
};

export const getDevices = async () => {
  const res = await apiFetch("/api/devices/last-reading-ts");
  if (!res) return [];
  if (res.status === 403) return [];
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.error || 'Error loading devices');
    err.status = res.status;
    throw err;
  }
  return res.json();
};

export const createDevice = async (data) => {
  const res = await apiFetch("/api/devices", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.error || "Error creating device");
    err.status = res.status;
    throw err;
  }

  return res.json(); // o `return true` si no devuelves nada
};

export const updateDevice = async (id, data) => {
  const res = await apiFetch(`/api/devices/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.error || "Error creating device");
    err.status = res.status;
    throw err;
  }

  return res.json();
}

export const deleteDevice = (id) =>
  apiFetch(`/api/devices/${id}`, {
    method: "DELETE",
  }
);

export const getDeviceElements = async (id) => {
  const res = await apiFetch(`/api/devices/${id}/elements`);
  if (!res.ok) throw new Error("Error fetching device elements");
  return res.json();
}
